import React, { FC, useState } from 'react';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { permissions } from 'utils/permission';
import { OrderInputType } from 'models/order-input/shared';
import { LabOrderContext } from './lab-order-context';
import LabOrder from './lab-order.component';
import { LabOrderInput } from 'models/order-input/lab-order';
import { emptyConstruction } from 'components/order-flow/lab-order/constructions-helper';
import { CONSTANTS } from 'config/constants';
import { customerSettings } from 'utils/customerSettings';

const CreateLabOrder: FC = () => {
    const currentOrg = currentOrgVar();

    const [order, setOrder] = useState<LabOrderInput>({
        inputType: OrderInputType.NEW,
        isActionBasedOrder: false,
        isWhiteLabeled: permissions.isWhiteLabeledOrganization(currentOrg),
        supplier: { _id: currentOrg._id },
        customer: undefined,
        dentist: undefined,
        constructions: [emptyConstruction()],
        files: [],
        historicalComments: [],
        comment: '',
        deliveryDetails: {
            date: new Date(),
            time: {
                hour: undefined,
                minute: undefined,
            },
        },
        sample: { type: '', content: [], otherContent: '' },
        sampleReceivedDate: new Date(),
        internalDeliveryDate: null,
        externalDeliveryDate: null,
        productionPlanningSteps: [],
    } as LabOrderInput);
    const [isTioTandvardPricingEnabled, setIsTioTandvardPricingEnabled] = useState<boolean>(false);
    const isProductionPlanningEnabled = customerSettings.getCustomerSetting(
        currentOrg.customerSettings,
        CONSTANTS.SETTINGS_NAMES.PRODUCTION_PLANNING,
    );
    return (
        <LabOrderContext.Provider
            value={{
                order,
                setOrder,
                isTioTandvardPricingEnabled,
                setIsTioTandvardPricingEnabled,
                isProductionPlanningEnabled,
            }}
        >
            <LabOrder />
        </LabOrderContext.Provider>
    );
};

export default CreateLabOrder;
